const renting_car = `Hei, haluaisin tiedustella vuokra-autojen saatavuutta.
Tarkemmin sanottuna, onko sinulla 7-paikkaisia autoja saatavilla?
Lisäksi olen kiinnostunut vuokraamaan auton viikoksi.
Voisitteko antaa minulle lisätietoja saatavuudesta ja hinnoista?
Kiitos.`;
export default renting_car;